import {createUseStyles} from 'react-jss'
import Modal from '../Modal'
import InputField from '../InputField'
import Switch from '../Switch'
import {useTranslation} from 'react-i18next'
import {EmployeeEditor} from "./useEmployeeEditor";

interface Props {
  editor: EmployeeEditor
  onSaveClick?: () => void
  onCancelClick?: () => void
  visible: boolean
}

const EditEmployeeModal = ({
                             editor,
                             onSaveClick,
                             onCancelClick,
                             visible
                           }: Props) => {
  const styles = useStyles()
  const {t} = useTranslation(['common', 'employees']);

  const handleOnSave = () => {
    onSaveClick && onSaveClick()
  }

  const handleOnCancel = () => {
    onCancelClick && onCancelClick()
  }

  return (
    <Modal
      title={t('editEmployee', {ns: 'employees'})}
      visible={visible}
      okButtonTitle={t('save', {ns: 'common'})}
      cancelButtonTitle={t('cancel', {ns: 'common'})}
      onHide={() => handleOnCancel()}
      onOkClick={() => handleOnSave()}
      onCancelClick={() => handleOnCancel()}
      okButtonDisabled={!editor.isValid}
    >
      <div className={styles.sectionRow}>
        <h5 className={styles.sectionTitle}>{t('pause', {ns: 'employees'})}</h5>
        <div className={styles.row}>
          <Switch
            id='paused'
            key='paused'
            checked={editor.employee.paused}
            label={t('paused', {ns: 'common'})}
            onChange={value => editor.handleChange('paused', !editor.employee.paused)}
            tooltipText={t('pausedDescription', {ns: 'employees'})}
          />
        </div>
        <div className={styles.row}>
          <InputField
            id='pauseReason'
            disabled={!editor.employee.paused}
            value={editor.employee.paused ? editor.employee.pauseReason : ''}
            onChange={value => editor.handleChange('pauseReason', value)}
            label={t('pauseReason', {ns: 'employees'})}
            placeholder=''
          />
        </div>
      </div>
      <div className={styles.sectionRow}>
        <h5 className={styles.sectionTitle}>{t('termination', {ns: 'employees'})}</h5>
        <div className={styles.row}>
          <Switch
            id='extendTerminationToUpcomingPayday'
            key='extendTerminationToUpcomingPayday'
            checked={editor.employee.extendTerminationToUpcomingPayday}
            label={t('extendTerminationToUpcomingPayday', {ns: 'employees'})}
            onChange={value => editor.handleChange('extendTerminationToUpcomingPayday', !editor.employee.extendTerminationToUpcomingPayday)}
            tooltipText={t('extendTerminationToUpcomingPaydayDescription', {ns: 'employees'})}
          />
        </div>
      </div>
      <div className={styles.sectionRow}>
        <h5 className={styles.sectionTitle}>{t('flags', {ns: 'common'})}</h5>
        <div className={styles.row}>
          <Switch
            id='nonEligible'
            key='nonEligible'
            checked={editor.employee.nonEligible}
            label={t('nonEligible', {ns: 'employees'})}
            onChange={value => editor.handleChange('nonEligible', !editor.employee.nonEligible)}
            tooltipText={t('nonEligibleDescription', {ns: 'employees'})}
          />
        </div>
        <div className={styles.row}>
          <Switch
            id='underForeclosure'
            key='underForeclosure'
            checked={editor.employee.underForeclosure}
            label={t('underForeclosure', {ns: 'employees'})}
            onChange={value => editor.handleChange('underForeclosure', !editor.employee.underForeclosure)}
            tooltipText={t('underForeclosureDescription', {ns: 'employees'})}
          />
        </div>
      </div>
    </Modal>
  )
}

export default EditEmployeeModal

const useStyles = createUseStyles({
  row: {
    paddingBottom: 12
  },
  sectionTitle: {
    marginBottom: 15
  },
  sectionRow: {
    paddingBottom: 25
  }
})
